module.exports = __webpack_public_path__ + "static/media/ticket-alerta.03393733.svg";